const ProductPromoType = Object.freeze({
	SAMPLING: 'sampling',
	ADDON: 'addon',
	BUY_X_PAY_Y: 'buy_x_pay_y',
	DISCOUNT_ON_X: 'discount_on_x',
	DISCOUNT_AFTER_X: 'discount_after_x',
	COMBO: 'combo',
})

const ProductPromoTypesNames = Object.freeze({
	[ProductPromoType.SAMPLING]: 'Producto de Regalo',
	// [ProductPromoType.ADDON]: 'Producto Adicional / Addon',
	[ProductPromoType.BUY_X_PAY_Y]: 'Compra X Paga Y',
	[ProductPromoType.COMBO]: 'Combo / Kit',
	[ProductPromoType.DISCOUNT_ON_X]: 'Descuento en la unidad X',
	[ProductPromoType.DISCOUNT_AFTER_X]: 'Descuento después de la unidad X',
})

module.exports = {
	ProductPromoType,
	ProductPromoTypesNames,
}

